import { blogHomepageFeaturedArticles as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  blogHeader: 'Blog Spotlight',
  viewAllArticlesButtonText: 'View All Articles',
  contentfulTagIds: 'americas',
};

export default fakeProps(schema, TestData);
